import React from 'react';
import { connect } from 'react-redux';
import styled, { withTheme } from 'styled-components';
import get from 'lodash/get';
import BreadcrumbWrapper from '../../Components/UIElements/Breadcrumb/wrapper';
import GlobalProgress from '../../Components/UIElements/GlobalProgress';
import { getCssValue } from '../../cruxComponents/utils';
import LeftPanelQuestions from '../../Pages/LandingPage/leftPanelQuestions';

const SmallScreenWrapper = styled.div`
  background: ${({ background }) => background || '#f7f7f7'};
  width: 100%;
  top: 0;
  box-sizing: content-box;
`;

const NormalScreenWrapper = styled.div`
  // background: ${({ background }) => background || '#f7f7f7'};
  width: ${({ width }) => width};
  position: relative;
  max-width: ${({ maxWidth }) => maxWidth || '330px'};
  margin: 0 20px;
  box-sizing: content-box;
  @media (min-width: 200px) and (max-width: 350px) {
    max-width: 300px;
  }
  ${({ showDivider }) =>
    showDivider &&
    `
    &:after {
      content: "";
      position: absolute;
      right: 0;
      top: 35px;
      bottom: 80px;
      width: 1px;
      background: #262d3f;
    }
  `}
`;

const Left = ({ screenViewport, layout, leftData, leftSidebarColor, theme, hideBreadcrumbs }) => {
  const _maxWidth = getCssValue(theme, 'maxWidth', 'left-normalScreenWrapper');
  const _width = getCssValue(theme, 'width', 'left-normalScreenWrapper');

  const showDivider = get(theme, `config.theme.pageOverrides.${theme.pageId}.showDivider`);

  if (hideBreadcrumbs && hideBreadcrumbs === true) {
    return null;
  }

  if (screenViewport === 'mobile' && layout === 'double' && !leftData.length) {
    return (
      <SmallScreenWrapper
        background={ leftSidebarColor }
        screenViewport={ screenViewport }
        data-name='left'
      >
        <GlobalProgress screenViewport={ screenViewport } />
      </SmallScreenWrapper>
    );
  }
  if (leftData.length) {
    // Hiding Left panel in small screen sizes for navy mutual
    if (process.env.REACT_APP_CARRIER_ID === 'nm' && screenViewport !== 'desktop') {
      return null;
    }
    return (
      <NormalScreenWrapper
        background={ leftSidebarColor }
        screenViewport={ screenViewport }
        data-name='left'
        width={ screenViewport === 'mobile' && leftData.length ? '100%' : _width }
        maxWidth={ _maxWidth }
        showDivider={ showDivider }
      >
        <LeftPanelQuestions leftData={ leftData } />
      </NormalScreenWrapper>
    );
  }
  if (layout === 'double') {
    return (
      <NormalScreenWrapper
        background={ leftSidebarColor }
        screenViewport={ screenViewport }
        data-name='left'
        width={ screenViewport === 'mobile' && leftData.length ? '100%' : _width }
        maxWidth={ _maxWidth }
        showDivider={ showDivider }
      >
        <BreadcrumbWrapper />
      </NormalScreenWrapper>
    );
  }
  return null;
};

function mapStateToProps({ questions }) {
  return {
    hideBreadcrumbs: questions.hideBreadcrumbs,
  };
}
export default withTheme(connect(mapStateToProps)(Left));
